/**
 * Squidd Info Popups JavaScript
 *
 * This file handles the modal functionality for the Info Popups section.
 * It should be included in your theme's assets directory.
 */

(function() {
    // Initialize once the DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        initInfoPopups();
    });

    /**
     * Initialize the Info Popups functionality
     */
    /**
     * Initialize the Info Popups functionality
     */
    function initInfoPopups() {
        // Get all popup triggers
        const triggers = document.querySelectorAll('[data-modal-trigger]');

        // Add click event listeners to each trigger
        triggers.forEach(trigger => {
            trigger.addEventListener('click', function() {
                const modalId = this.getAttribute('data-modal-trigger');
                openModal(modalId);
            });
        });

        // Get all close buttons
        const closeButtons = document.querySelectorAll('[data-modal-close]');

        // Add click event listeners to each close button
        closeButtons.forEach(button => {
            button.addEventListener('click', function() {
                const modal = this.closest('.squidd-info-popups__modal');
                closeModal(modal);
            });
        });

        // Close modal when clicking on the overlay (outside the modal content)
        const modals = document.querySelectorAll('.squidd-info-popups__modal');
        modals.forEach(modal => {
            modal.addEventListener('click', function(event) {
                if (event.target === this) {
                    closeModal(this);
                }
            });
        });

        // Add keyboard support (ESC to close)
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                const openModal = document.querySelector('.squidd-info-popups__modal.is-active');
                if (openModal) {
                    closeModal(openModal);
                }
            }
        });

        // Initialize SVG icons from templates
        initIconsFromTemplates();
    }

    /**
     * Initialize SVG icons from template elements
     * Note: This function is no longer needed as we're embedding SVGs directly
     */
    function initIconsFromTemplates() {
        // Icons are now directly embedded in the section template
        // This function is kept for backward compatibility
    }

    /**
     * Open a modal by ID
     * @param {string} modalId - The ID of the modal to open
     */
    function openModal(modalId) {
        const modal = document.getElementById(`modal-${modalId}`);

        if (modal) {
            // Close any open modals first
            const openModals = document.querySelectorAll('.squidd-info-popups__modal.is-active');
            openModals.forEach(openModal => {
                closeModal(openModal);
            });

            // Add active class to display the modal
            modal.classList.add('is-active');

            // Prevent body scrolling while modal is open
            document.body.style.overflow = 'hidden';

            // Trigger a custom event
            modal.dispatchEvent(new CustomEvent('squidd:modal:opened', {
                bubbles: true,
                detail: { modalId }
            }));
        }
    }

    /**
     * Close a modal
     * @param {HTMLElement} modal - The modal element to close
     */
    function closeModal(modal) {
        if (modal) {
            // Remove active class
            modal.classList.remove('is-active');

            // Restore body scrolling
            document.body.style.overflow = '';

            // Trigger a custom event
            modal.dispatchEvent(new CustomEvent('squidd:modal:closed', {
                bubbles: true
            }));
        }
    }
})();